import {
  BillingIcon,
  BillingInfoIcon,
  CDRIcon,
  DashboardIcon,
  DIDIcon,
  InventryIcon,
  CRMIcon,
  NetworkIcon,
  NonRecurringIcon,
  NotificationIcon,
  PackageIcon,
  PaymentIcon,
  ProductIcon,
  RateIcon,
  RoleIcon,
  ServerIcon,
  ServiceIcon,
  SettingIcon,
  UserIcon,
  UsersIcon,
  VendorIcon,
  Billing1Icon,
  SystemSettingsIcon,
} from './icons';

export const ROROTEL_ACCESS_TOKEN = 'rorotel-access-token';
export const SIDEBAR_COLLAPSE = 'sidebar-collapse';
export const LOGOUT_USER = 'logout-user';
export const DELETE_CONFIRM_MODAL = 'delete-confirm-modal';
export const CONFIRM_MODAL = 'confirm-modal';
export const INFO_MODAL = 'info-modal';
export const REFECTH_QUERY = 'refetch-query';
export const ACCESS_ROLE = 'access-role';

export const editForm = { isEdit: false, formData: {} };

export const emailMaxLength = 50;
export const passwordMaxLength = 30;
export const nameMaxLength = 50;
export const pincodeMaxLength = 20;
export const descriptionMaxLength = 200;

export const maxLength10 = 10;
export const maxLength15 = 15;
export const maxLength20 = 20;
export const maxLength30 = 30;
export const maxLength50 = 50;
export const maxLength100 = 100;
export const maxLength200 = 200;
export const maxLength255 = 255;
export const maxLength500 = 500;
export const maxLength1000 = 1000;

export const FULL = 'full';
export const READ = 'read';
export const ADMIN = 'admin';
export const CUSTOMER = 'customer';
export const PROVIDER = 'provider';
export const SUB_PROVIDER = 'sub-provider';
export const RESELLER = 'reseller';

export const PAGES = {
  // provider
  USERS: 'users',
  ROLES: 'roles',
  CUSTOMERS: 'customers',
  PRODUCTS: 'products',
  PACKAGES: 'packages',
  DID: 'did',
  INVENTORY: 'inventory',
  PAYMENTS: 'payments',
  INVOICES: 'invoices',
  RATES: 'rates',
  VENDORS: 'vendors',
  SERVICES: 'services',
  // customer
  CUSTOMER_PRODUCTS: 'customer-products',
  CUSTOMER_PACKAGES: 'customer-packages',
  CUSTOMER_DID: 'customer-did',
  CUSTOMER_PAYMENTS: 'customer-payments',
  CUSTOMERS_INVOICES: 'customers-invoices',
  CUSTOMER_CDR: 'customer-cdr',
  CUSTOMER_RATES: 'customer-rates',
};

export const sidebarIcons = {
  dashboard: DashboardIcon,
  'cron-runs': SystemSettingsIcon,
  'audit-logs': SystemSettingsIcon,
  users: UserIcon,
  roles: RoleIcon,
  customers: UsersIcon,
  resellers: UsersIcon,
  'shared-pbx': BillingInfoIcon,
  crm: CRMIcon,
  'lead-master': CRMIcon,
  products: ProductIcon,
  'customer-products': ProductIcon,
  packages: PackageIcon,
  'customer-packages': PackageIcon,
  did: DIDIcon,
  'customer-did': DIDIcon,
  inventory: InventryIcon,
  payments: PaymentIcon,
  'customer-payments': PaymentIcon,
  invoices: BillingIcon,
  'customer-invoices': BillingIcon,
  cdr: CDRIcon,
  'customer-cdr': CDRIcon,
  rates: RateIcon,
  'customer-rates': RateIcon,
  servers: ServerIcon,
  vendors: VendorIcon,
  'vendors-and-services': VendorIcon,
  services: ServiceIcon,
  Services: ServiceIcon,
  notifications: NotificationIcon,
  'pdf-template': BillingInfoIcon,
  'general-settings': SettingIcon,
  'zone-networks': NetworkIcon,
  'billing-reports': BillingInfoIcon,
  "billing": Billing1Icon,
  'non-recurring': NonRecurringIcon,
  "system-settings": SystemSettingsIcon
};

export const currency = [
  {
    label: '(£) GBP',
    value: 'gbp',
  },
  {
    label: '(€) EUR',
    value: 'eur',
  },
  {
    label: '($) USD',
    value: 'usd',
  },
];

export const DateFilterTypes = [
  { label: 'Today', value: 'Today' },
  { label: 'Yesterday', value: 'Yesterday' },
  { label: 'Last 7 Days', value: 'Last 7 Days' },
  { label: 'Last 30 Days', value: 'Last 30 Days' },
  { label: 'This Month', value: 'This Month' },
  { label: 'Last Month', value: 'Last Month' },
  { label: 'Last 3 Months', value: 'Last 3 Months' },
  { label: 'Last 6 Months', value: 'Last 6 Months' },
  { label: 'Last 12 Months', value: 'Last 12 Months' },
  { label: 'Last 24 Months', value: 'Last 24 Months' },
  { label: 'Custom', value: 'Custom' },
];

export const filterDateDropdown = {
  value: {
    from: '',
    to: '',
  },
  date_type: '',
  dateOptions: DateFilterTypes,
};
